<template>
  <div ref="wrap">
    <div class="flex"
      >阅读并接受电子保函系统<div class="px-1.5 text-blue-500" @click="showpolicy(1)">用户协议</div
      >和<div class="px-1.5 text-blue-500" @click="showpolicy(2)">隐私政策</div></div
    >
    <a-modal
      :destroyOnClose="true"
      :visible="visible"
      footer=""
      :width="'60rem'"
      :title="titlepolicy"
      :bodyStyle=bodytyle
      @ok="handleOk"
      @cancel="visible = false"
      ><div v-html="res" class="m-20px"></div
    ></a-modal>
  </div>
</template>
<script>
  import { config } from '@/api/config';
  export default {
    data() {
      return {
        filesrc: '',
        filename: '',
        loading: false,
        visible: false,
        titlepolicy: '',
        res: '',
        bodytyle:{ "overflow-y": "auto", "max-height": "calc(80vh - 150px)"}
      };
    },
    mounted() {},
    methods: {
      async showpolicy(index) {
        this.visible = true;
        if (index == 1) {
          this.titlepolicy = '电子保函用户协议';
          this.res = (await config()).agreement;
        } else {
          this.titlepolicy = '电子保函隐私政策';
          this.res = (await config()).privacy;
        }
      },
      handleOk() {
        this.visible = false;
      },
      async api(e) {
        let formData = new FormData();
        formData.append('file', e.file);
        formData.append('where', 'file');
        formData.append('style', '1');
        this.loading = true;
        let res = await this.$uploadfile('/api/v1/file_upload', formData);
        this.filesrc = res.pathname;
        this.filename = res.filename;
        this.$emit('upload', res);
        this.loading = false;
      },
    },
  };
</script>
